import { render, staticRenderFns } from "./informationdetail.vue?vue&type=template&id=c9306594&scoped=true&"
import script from "./informationdetail.vue?vue&type=script&lang=js&"
export * from "./informationdetail.vue?vue&type=script&lang=js&"
import style0 from "./informationdetail.vue?vue&type=style&index=0&id=c9306594&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9306594",
  null
  
)

export default component.exports